import ProgressService from "@/services/progress.service";
import AuthService from "@/services/auth.service";

const axios = require('axios')

const defaultOptions = {
    baseURL: process.env.VUE_APP_CHAT_API_URL,
    addTokenToHeader: true,
    headers: {
        'Content-Type': 'application/json',
        'accept-language': 'fa',
    }
};

let axiosChatInstance = axios.create(defaultOptions);

axiosChatInstance.interceptors.request.use(
    config => {
        AuthService.addTokenToRequest(config)

        ProgressService.startRequest()

        return config;
    }, error => {
        ProgressService.doneRequest()
        return Promise.reject(error)
    });

axiosChatInstance.interceptors.response.use(
    response => {
        ProgressService.doneRequest()
        return response;
    }, error => {
        ProgressService.doneRequest()
        return Promise.reject(error)
    }
);

export default axiosChatInstance;